module.exports = __webpack_public_path__ + "img/excellent.0630bb46.svg";